export interface CategoryComic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: string;
  status: 'ongoing' | 'completed';
  rating: number;
  views: string;
  latestChapter: string;
  description: string;
  tags: string[];
}

export const romanceComics: CategoryComic[] = [
  {
    id: 'romance-01',
    title: '甜蜜契约',
    author: 'PARK美妍',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20sweet%20love%20story%2C%20couple%20in%20warm%20embrace%2C%20soft%20pink%20and%20peach%20color%20palette%2C%20romantic%20sunset%20background%2C%20beautiful%20digital%20illustration%2C%20clean%20composition%2C%20webtoon%20style%20art&width=800&height=1100&seq=romance-01&orientation=portrait',
    category: '恋爱甜宠',
    status: 'ongoing',
    rating: 9.5,
    views: '2100万',
    latestChapter: '第156话',
    description: '一纸契约让两个陌生人走到一起，却在相处中慢慢产生真挚感情。甜蜜与心动交织的恋爱物语。',
    tags: ['契约恋爱', '甜宠', '治愈'],
  },
  {
    id: 'romance-02',
    title: '初恋回忆录',
    author: 'KIM恩熙',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20first%20love%20nostalgic%20story%2C%20high%20school%20students%20under%20cherry%20blossoms%2C%20soft%20pastel%20colors%2C%20warm%20spring%20atmosphere%2C%20youthful%20romance%2C%20beautiful%20digital%20art%2C%20clean%20composition&width=800&height=1100&seq=romance-02&orientation=portrait',
    category: '恋爱甜宠',
    status: 'completed',
    rating: 9.7,
    views: '3800万',
    latestChapter: '第200话（完结）',
    description: '从青涩的校园初恋到多年后的重逢，一段跨越时光的爱情故事，让人回忆起最美好的青春年华。',
    tags: ['校园', '初恋', '重逢'],
  },
  {
    id: 'romance-03',
    title: '总裁的专属秘书',
    author: 'LEE智慧',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20office%20romance%2C%20elegant%20businessman%20and%20secretary%2C%20modern%20office%20setting%2C%20sophisticated%20warm%20tones%2C%20professional%20digital%20illustration%2C%20clean%20composition%2C%20romantic%20tension&width=800&height=1100&seq=romance-03&orientation=portrait',
    category: '恋爱甜宠',
    status: 'ongoing',
    rating: 9.3,
    views: '1560万',
    latestChapter: '第88话',
    description: '冷酷总裁与聪明秘书之间，从最初的针锋相对到后来的相互吸引。一段甜中带笑的职场恋情。',
    tags: ['职场', '霸道总裁', '甜宠'],
  },
  {
    id: 'romance-04',
    title: '青梅竹马养成记',
    author: 'CHOI柔美',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20childhood%20friends%20to%20lovers%2C%20warm%20cozy%20neighborhood%20scene%2C%20soft%20warm%20tones%2C%20nostalgic%20atmosphere%2C%20tender%20relationship%20art%2C%20beautiful%20digital%20illustration%2C%20slice%20of%20life%20style&width=800&height=1100&seq=romance-04&orientation=portrait',
    category: '恋爱甜宠',
    status: 'ongoing',
    rating: 9.4,
    views: '1890万',
    latestChapter: '第112话',
    description: '从小一起长大的邻居，一直以兄妹相称。直到有一天，心中的感情突然变了味道。',
    tags: ['青梅竹马', '养成', '日常'],
  },
];

export const actionComics: CategoryComic[] = [
  {
    id: 'action-01',
    title: '暗影战士',
    author: 'JUNG铁血',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20dark%20warrior%20action%20fantasy%2C%20shadowy%20hero%20with%20glowing%20sword%2C%20dramatic%20red%20and%20black%20tones%2C%20epic%20battle%20scene%2C%20dynamic%20action%20pose%2C%20professional%20digital%20art%2C%20powerful%20composition&width=800&height=1100&seq=action-01&orientation=portrait',
    category: '热血冒险',
    status: 'ongoing',
    rating: 9.6,
    views: '2950万',
    latestChapter: '第178话',
    description: '被命运选中的少年，踏上成为最强战士的道路。黑暗势力步步紧逼，他必须不断变强才能守护重要之人。',
    tags: ['战斗', '成长', '热血'],
  },
  {
    id: 'action-02',
    title: '龙骑士传说',
    author: 'KANG天翼',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20dragon%20rider%20fantasy%20adventure%2C%20mighty%20dragon%20and%20young%20rider%2C%20epic%20sky%20battle%20background%2C%20vibrant%20orange%20and%20gold%20tones%2C%20fantasy%20world%20setting%2C%20professional%20digital%20art%2C%20cinematic%20composition&width=800&height=1100&seq=action-02&orientation=portrait',
    category: '热血冒险',
    status: 'ongoing',
    rating: 9.4,
    views: '2200万',
    latestChapter: '第134话',
    description: '少年与古老巨龙缔结契约，翱翔于天际守护王国。史诗般的冒险旅程，宏大的世界观设定。',
    tags: ['龙', '奇幻', '冒险'],
  },
  {
    id: 'action-03',
    title: '地下城之王',
    author: 'PARK猎手',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20dungeon%20crawler%20game%20world%2C%20hero%20in%20armor%20exploring%20dark%20dungeon%2C%20mysterious%20blue%20torch%20light%2C%20dangerous%20atmosphere%2C%20professional%20digital%20art%2C%20RPG%20aesthetic%2C%20clean%20composition&width=800&height=1100&seq=action-03&orientation=portrait',
    category: '热血冒险',
    status: 'completed',
    rating: 9.8,
    views: '4200万',
    latestChapter: '第256话（完结）',
    description: '最强猎人深入无尽地下城，每一层都有更强大的怪物在等待。从无名小卒到地下城之王的传奇征程。',
    tags: ['地下城', '升级', '热血'],
  },
  {
    id: 'action-04',
    title: '机甲风暴',
    author: 'LEE钢铁',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20mecha%20robot%20battle%20sci-fi%2C%20giant%20mecha%20in%20dynamic%20combat%20pose%2C%20cyberpunk%20city%20background%2C%20neon%20blue%20and%20orange%20tones%2C%20high%20tech%20atmosphere%2C%20professional%20digital%20art%2C%20action%20packed%20composition&width=800&height=1100&seq=action-04&orientation=portrait',
    category: '热血冒险',
    status: 'ongoing',
    rating: 9.2,
    views: '1680万',
    latestChapter: '第98话',
    description: '人类最后的希望——巨型机甲与外星入侵者的终极对决。热血机师驾驶钢铁巨人守护地球。',
    tags: ['机甲', '科幻', '战斗'],
  },
];

export const mysteryComics: CategoryComic[] = [
  {
    id: 'mystery-01',
    title: '消失的妻子',
    author: 'KIM悬疑',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20mystery%20thriller%20disappearance%2C%20dark%20moody%20atmosphere%2C%20mysterious%20shadow%20figure%20in%20fog%2C%20deep%20teal%20and%20dark%20blue%20color%20scheme%2C%20suspenseful%20mood%2C%20professional%20digital%20art%2C%20noir%20aesthetic&width=800&height=1100&seq=mystery-01&orientation=portrait',
    category: '悬疑推理',
    status: 'completed',
    rating: 9.8,
    views: '3600万',
    latestChapter: '第168话（完结）',
    description: '妻子离奇失踪，丈夫踏上寻找真相之路。随着调查深入，一个惊人阴谋浮出水面。层层反转，不到最后猜不到结局。',
    tags: ['悬疑', '犯罪', '反转'],
  },
  {
    id: 'mystery-02',
    title: '天才侦探金明浩',
    author: 'LEE推理',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20detective%20genius%20sleuth%20story%2C%20clever%20young%20detective%20with%20magnifying%20glass%2C%20crime%20scene%20background%20with%20clues%2C%20dark%20atmospheric%20tones%2C%20intellectual%20thriller%20aesthetic%2C%20professional%20digital%20art&width=800&height=1100&seq=mystery-02&orientation=portrait',
    category: '悬疑推理',
    status: 'ongoing',
    rating: 9.6,
    views: '2400万',
    latestChapter: '第145话',
    description: '拥有超凡观察力的天才侦探，破解一桩桩看似不可能的悬案。智商在线，推理严密，每一话都是头脑风暴。',
    tags: ['侦探', '推理', '烧脑'],
  },
  {
    id: 'mystery-03',
    title: '时间循环之谜',
    author: 'PARK时空',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20time%20loop%20mystery%20supernatural%2C%20clock%20and%20spiral%20time%20elements%2C%20ethereal%20purple%20and%20silver%20tones%2C%20mysterious%20atmosphere%2C%20time%20travel%20aesthetic%2C%20professional%20digital%20art%2C%20mind%20bending%20composition&width=800&height=1100&seq=mystery-03&orientation=portrait',
    category: '悬疑推理',
    status: 'ongoing',
    rating: 9.5,
    views: '1900万',
    latestChapter: '第98话',
    description: '主角被困在同一天不断循环，只有解开死亡之谜才能打破轮回。时间与真相的追逐，脑洞大开。',
    tags: ['时间循环', '超自然', '悬疑'],
  },
  {
    id: 'mystery-04',
    title: '死亡直播间',
    author: 'JUNG暗影',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20dark%20thriller%20streaming%20horror%2C%20smartphone%20screen%20with%20ominous%20red%20glow%2C%20terrifying%20livestream%20concept%2C%20deep%20red%20and%20black%20tones%2C%20modern%20horror%20aesthetic%2C%20professional%20digital%20art%2C%20suspenseful%20mood&width=800&height=1100&seq=mystery-04&orientation=portrait',
    category: '悬疑推理',
    status: 'completed',
    rating: 9.7,
    views: '3100万',
    latestChapter: '第188话（完结）',
    description: '一场直播秀演变成死亡游戏，百万观众成为见证者。谁能活到最后？致命直播间的生存法则。',
    tags: ['直播', '生存', '惊悚'],
  },
];

export const healingComics: CategoryComic[] = [
  {
    id: 'healing-01',
    title: '猫咪咖啡馆',
    author: 'CHOI喵喵',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20cat%20cafe%20healing%20slice%20of%20life%2C%20cute%20cats%20and%20warm%20coffee%20shop%20interior%2C%20soft%20cream%20and%20warm%20beige%20tones%2C%20cozy%20peaceful%20atmosphere%2C%20adorable%20feline%20characters%2C%20professional%20digital%20art%2C%20comforting%20composition&width=800&height=1100&seq=healing-01&orientation=portrait',
    category: '治愈日常',
    status: 'ongoing',
    rating: 9.6,
    views: '1750万',
    latestChapter: '第95话',
    description: '街角猫咪咖啡馆里，每一只猫咪都有自己的故事。温柔的日常，治愈你疲惫的心灵。',
    tags: ['猫咪', '治愈', '日常'],
  },
  {
    id: 'healing-02',
    title: '山间小屋',
    author: 'PARK清风',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20mountain%20cottage%20peaceful%20nature%2C%20cozy%20wooden%20house%20in%20forest%2C%20soft%20green%20and%20warm%20brown%20tones%2C%20serene%20natural%20atmosphere%2C%20beautiful%20landscape%20art%2C%20professional%20digital%20illustration%2C%20calming%20composition&width=800&height=1100&seq=healing-02&orientation=portrait',
    category: '治愈日常',
    status: 'ongoing',
    rating: 9.5,
    views: '1320万',
    latestChapter: '第72话',
    description: '逃离城市喧嚣，在山间小屋过着自给自足的生活。种植、烹饪、看星空，最简单的幸福。',
    tags: ['自然', '慢生活', '治愈'],
  },
  {
    id: 'healing-03',
    title: '下班后的居酒屋',
    author: 'KIM微醺',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20izakaya%20after%20work%20healing%20story%2C%20warm%20cozy%20japanese%20pub%20atmosphere%2C%20soft%20lantern%20light%2C%20warm%20amber%20and%20wood%20tones%2C%20relaxing%20evening%20vibe%2C%20professional%20digital%20art%2C%20slice%20of%20life%20aesthetic&width=800&height=1100&seq=healing-03&orientation=portrait',
    category: '治愈日常',
    status: 'completed',
    rating: 9.7,
    views: '2100万',
    latestChapter: '第120话（完结）',
    description: '下班后的小酌时光，居酒屋老板的故事和料理治愈每个疲惫的灵魂。美食与温情并存的日常。',
    tags: ['美食', '居酒屋', '治愈'],
  },
  {
    id: 'healing-04',
    title: '花园手札',
    author: 'LEE花语',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20gardening%20flower%20healing%20story%2C%20beautiful%20flower%20garden%20with%20butterflies%2C%20soft%20pastel%20pink%20and%20green%20tones%2C%20peaceful%20gardening%20atmosphere%2C%20botanical%20illustration%20style%2C%20professional%20digital%20art%2C%20calming%20composition&width=800&height=1100&seq=healing-04&orientation=portrait',
    category: '治愈日常',
    status: 'ongoing',
    rating: 9.4,
    views: '980万',
    latestChapter: '第58话',
    description: '继承祖母的花店，用花草治愈他人的同时也治愈自己。每一朵花背后都有一个温暖的故事。',
    tags: ['花店', '园艺', '治愈'],
  },
];

export const fantasyComics: CategoryComic[] = [
  {
    id: 'fantasy-01',
    title: '灵能者学院',
    author: 'JUNG魔法',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20magic%20academy%20supernatural%20school%2C%20mystical%20castle%20school%20building%20with%20magical%20auras%2C%20teal%20and%20emerald%20glowing%20tones%2C%20fantasy%20world%20setting%2C%20enchanting%20atmosphere%2C%20professional%20digital%20art%2C%20magical%20composition&width=800&height=1100&seq=fantasy-01&orientation=portrait',
    category: '奇幻异界',
    status: 'ongoing',
    rating: 9.4,
    views: '1980万',
    latestChapter: '第128话',
    description: '拥有罕见灵能的少年被特招进入精英学院。在这个充满魔法的世界里，他将揭开自己身世的秘密。',
    tags: ['魔法学院', '超能力', '成长'],
  },
  {
    id: 'fantasy-02',
    title: '精灵之森',
    author: 'PARK自然',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20elf%20forest%20fantasy%20world%2C%20beautiful%20elf%20character%20in%20enchanted%20forest%2C%20magical%20glowing%20plants%20and%20creatures%2C%20green%20and%20gold%20ethereal%20tones%2C%20mystical%20atmosphere%2C%20professional%20digital%20art%2C%20fantasy%20aesthetic&width=800&height=1100&seq=fantasy-02&orientation=portrait',
    category: '奇幻异界',
    status: 'ongoing',
    rating: 9.6,
    views: '2600万',
    latestChapter: '第156话',
    description: '人类少年误入精灵之森，与精灵公主一同对抗黑暗势力的入侵。异世界的史诗冒险就此展开。',
    tags: ['精灵', '异世界', '冒险'],
  },
  {
    id: 'fantasy-03',
    title: '重生大魔王',
    author: 'KANG暗黑',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20demon%20lord%20reincarnation%20dark%20fantasy%2C%20powerful%20demon%20king%20with%20dark%20aura%2C%20crimson%20and%20black%20ominous%20tones%2C%20dark%20fantasy%20atmosphere%2C%20overwhelming%20power%20aesthetic%2C%20professional%20digital%20art%2C%20epic%20composition&width=800&height=1100&seq=fantasy-03&orientation=portrait',
    category: '奇幻异界',
    status: 'completed',
    rating: 9.7,
    views: '3900万',
    latestChapter: '第220话（完结）',
    description: '曾经的大魔王转生为弱小的人类少年，拥有前世记忆的他决心重新登上权力巅峰。暗黑系爽文。',
    tags: ['重生', '魔王', '爽文'],
  },
  {
    id: 'fantasy-04',
    title: '星际流浪者',
    author: 'LEE星际',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20space%20wanderer%20sci-fi%20fantasy%2C%20lone%20traveler%20in%20vast%20cosmic%20space%2C%20stars%20and%20nebula%20background%2C%20deep%20blue%20and%20purple%20cosmic%20tones%2C%20epic%20space%20adventure%20atmosphere%2C%20professional%20digital%20art%2C%20cinematic%20composition&width=800&height=1100&seq=fantasy-04&orientation=portrait',
    category: '奇幻异界',
    status: 'ongoing',
    rating: 9.3,
    views: '1450万',
    latestChapter: '第86话',
    description: '在浩瀚星际间流浪的少年，驾驶古老飞船探索未知星球。科幻与奇幻交织的宇宙冒险。',
    tags: ['星际', '科幻', '冒险'],
  },
];

export const dramaComics: CategoryComic[] = [
  {
    id: 'drama-01',
    title: '首尔夜行者',
    author: 'KIM都市',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20seoul%20night%20city%20urban%20drama%2C%20neon%20lit%20seoul%20streets%20at%20night%2C%20rainy%20reflections%20on%20asphalt%2C%20deep%20blue%20and%20warm%20yellow%20neon%20tones%2C%20urban%20noir%20atmosphere%2C%20professional%20digital%20art%2C%20moody%20composition&width=800&height=1100&seq=drama-01&orientation=portrait',
    category: '都市剧情',
    status: 'ongoing',
    rating: 9.5,
    views: '2200万',
    latestChapter: '第118话',
    description: '在首尔这座不夜城，不同阶层的人物命运交织。职场斗争、爱情故事、人生抉择，真实的都市群像。',
    tags: ['都市', '群像', '现实'],
  },
  {
    id: 'drama-02',
    title: '继承者们',
    author: 'PARK豪门',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20chaebol%20family%20succession%20drama%2C%20luxurious%20mansion%20and%20wealthy%20family%20portrait%2C%20elegant%20gold%20and%20deep%20navy%20tones%2C%20sophisticated%20high%20society%20atmosphere%2C%20professional%20digital%20art%2C%20dramatic%20composition&width=800&height=1100&seq=drama-02&orientation=portrait',
    category: '都市剧情',
    status: 'completed',
    rating: 9.6,
    views: '3100万',
    latestChapter: '第180话（完结）',
    description: '财阀家族三代人的恩怨情仇，继承权争夺中的明争暗斗。金钱、权力与亲情之间的残酷抉择。',
    tags: ['财阀', '家族', '斗争'],
  },
  {
    id: 'drama-03',
    title: '创业时代',
    author: 'LEE梦想',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20startup%20entrepreneur%20story%2C%20young%20team%20in%20modern%20co-working%20space%2C%20bright%20optimistic%20energy%2C%20warm%20coral%20and%20white%20tones%2C%20ambitious%20atmosphere%2C%20professional%20digital%20art%2C%20inspiring%20composition&width=800&height=1100&seq=drama-03&orientation=portrait',
    category: '都市剧情',
    status: 'ongoing',
    rating: 9.2,
    views: '1200万',
    latestChapter: '第68话',
    description: '几个年轻人在创业路上跌跌撞撞，从失败中汲取教训，最终找到属于自己的成功之路。励志都市故事。',
    tags: ['创业', '励志', '职场'],
  },
  {
    id: 'drama-04',
    title: '医疗内幕',
    author: 'CHOI白衣',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20medical%20hospital%20drama%2C%20intense%20hospital%20corridor%20scene%2C%20doctor%20in%20white%20coat%20serious%20expression%2C%20clean%20blue%20and%20white%20clinical%20tones%2C%20tense%20medical%20atmosphere%2C%20professional%20digital%20art%2C%20dramatic%20composition&width=800&height=1100&seq=drama-04&orientation=portrait',
    category: '都市剧情',
    status: 'completed',
    rating: 9.7,
    views: '2800万',
    latestChapter: '第165话（完结）',
    description: '医院里的权力斗争、医患纠纷与医者仁心。白衣天使们在生死线上守护生命，也在人性边缘挣扎。',
    tags: ['医疗', '人性', '现实'],
  },
];

export const allComicsByCategory: Record<string, CategoryComic[]> = {
  romance: romanceComics,
  action: actionComics,
  mystery: mysteryComics,
  healing: healingComics,
  fantasy: fantasyComics,
  drama: dramaComics,
};

export const allComicsList: CategoryComic[] = [
  ...romanceComics,
  ...actionComics,
  ...mysteryComics,
  ...healingComics,
  ...fantasyComics,
  ...dramaComics,
];

export function getComicById(id: string): CategoryComic | undefined {
  return allComicsList.find((c) => c.id === id);
}